import { PropsWithChildren, useEffect } from "react";
import { MantineProvider } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "./store";
import {
  toggleRTL,
  toggleTheme,
  toggleMenu,
  toggleLayout,
  toggleAnimation,
  toggleNavbar,
  toggleSemidark,
} from "./store/themeConfigSlice";

function App({ children }: PropsWithChildren) {
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toggleTheme(localStorage.getItem("theme") || themeConfig.theme));
    dispatch(toggleMenu(localStorage.getItem("menu") || themeConfig.menu));
    dispatch(toggleLayout(localStorage.getItem("layout") || themeConfig.layout));
    dispatch(toggleRTL(localStorage.getItem("rtlClass") || themeConfig.rtlClass));
    dispatch(toggleAnimation(localStorage.getItem("animation") || themeConfig.animation));
    dispatch(toggleNavbar(localStorage.getItem("navbar") || themeConfig.navbar));
    dispatch(toggleSemidark(localStorage.getItem("semidark") || themeConfig.semidark));
  }, [dispatch, themeConfig]);

  return (
    <MantineProvider
      theme={{
        colorScheme: themeConfig.theme === "dark" ? "dark" : "light",
        primaryColor: "blue",
      }}
      withGlobalStyles
      withNormalizeCSS
    >
      <div
        className={`${themeConfig.sidebar ? "toggle-sidebar" : ""} ${themeConfig.menu} ${
          themeConfig.layout
        } ${themeConfig.rtlClass} main-section antialiased relative font-nunito text-sm font-normal`}
      >
        {children}
      </div>
    </MantineProvider>
  );
}

export default App;
